import React from "react";
import classnames from "classnames";

interface StatisticProps {
  number: string;
  title: string;
  introduction: string;
  className?: string;
  total: number;
}

export const Statistic: React.FC<StatisticProps> = ({
  number,
  introduction,
  title,
  className,
  total,
}) => {
  return (
    <li className={classnames("flex flex-col w-full", className)}>
      <span className="font-medium text-primary text-base">{title}</span>
      <div className="flex flex-col w-full text-center items-center pt-4 pb-12 md:py-14">
        <span className={classnames("font-normal text-primary leading-[1.2]", { "text-7xl": total < 4, "text-[40px]": total >= 4 })}>{number}</span>
        <span className="font-normal text-primary text-xl">{introduction}</span>
      </div>
    </li>
  );
};
